import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@styles/index.scss'
import App from './App.jsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const queryClient = new QueryClient();

createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <StrictMode>
      <App />
    </StrictMode>
  </QueryClientProvider>,
)
